import script from "./CartOfferRelated.vue?vue&type=script&setup=true&lang=js"
export * from "./CartOfferRelated.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__